import axios from "axios";

export function fetchCitiesByUF(uf) {
  return axios.get(`https://brasilapi.com.br/api/ibge/municipios/v1/${uf}`);
}
